import type { LevelResult } from '../store/gameStore';

export function averageMetric(results: LevelResult[], metric: 'accuracy' | 'reactionTime'): number {
  const valid = results.filter(r => metric === 'accuracy' ? r.accuracyMeasured !== false && Number.isFinite(r.accuracy) : Number.isFinite(r.reactionTime) && r.reactionTime > 0);
  return valid.length ? valid.reduce((sum, r) => sum + r[metric], 0) / valid.length : 0;
}

export function trainingMinutes(results: LevelResult[]): number {
  return Math.round(results.reduce((sum, r) => sum + (r.durationSeconds ?? 180), 0) / 60 * 10) / 10;
}
